export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path
                d="M5 8.53047C5 8.08864 5.35817 7.73047 5.8 7.73047H19.2C19.6418 7.73047 20 8.08864 20 8.53047V18.2305C20 18.5066 19.7761 18.7305 19.5 18.7305H5.5C5.22386 18.7305 5 18.5066 5 18.2305V8.53047Z"
                stroke="url(#paint0_linear_725_2426)"
            />
            <path
                d="M6.93987 5.79463C7.0344 5.66993 7.18185 5.59668 7.33832 5.59668H17.6617C17.8182 5.59668 17.9657 5.66994 18.0602 5.79464L19.4936 7.68555H5.50645L6.93987 5.79463Z"
                stroke="url(#paint1_linear_725_2426)"
            />
            <path d="M15.3235 12.3284H9.5L11.0882 11.1855M9.67647 14.0427H15.5L13.9118 15.1855" stroke="#DBAD6B" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_725_2426" x1="21.78" y1="6.59889" x2="5.94587" y2="19.4351" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FBD997" />
                    <stop offset="0.638002" stopColor="#C99352" />
                    <stop offset="1" stopColor="#C79150" />
                </linearGradient>
                <linearGradient id="paint1_linear_725_2426" x1="13.78" y1="5.3989" x2="19.2124" y2="8.46887" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#C89251" />
                    <stop offset="1" stopColor="#F2CC8B" />
                </linearGradient>
            </defs>
        </svg>
    );
}
